export const DataHooks = {
  label: 'signature-input-label',
  radioGroup: 'signature-input-radio-group',
  radioDraw: 'signature-input-radio-draw',
  radioType: 'signature-input-radio-type',
  canvas: 'signature-input-canvas',
  input: 'signature-input-input',
  clearButton: 'signature-input-clear-button',
};
